import { useState } from "react";

import {
  makeGetApiCall,
  makePostApiCall,
  makePostApiCallToPrinter,
} from "../../shared/makeApiCall";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";
import { SnackbarData, SnackbarType } from "../../components/Snackbar";
import { generateUniqueNumber } from "../../shared/utility";
import ProgressModal from "../../components/modals/ProgressModal";

export function ShippingDetailsViewModel(shippingId, logout, addSnackbar) {
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [shipping, setShipping] = useState(null);
  const [loading, setLoading] = useState(true);
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });

  const showProgressModal = (message = "Processing...") => {
    setEmptyModelOpen({
      childComponent: <ProgressModal message={message} />,
      open: true,
    });
  };

  const hideProgressModal = () => {
    setEmptyModelOpen({
      childComponent: null,
      open: false,
    });
  };

  const getShippingDetails = async function () {
    let callResult = await makePostApiCall(`fetchShipping/${shippingId}`);
    if (callResult.success) {
      const orderDetails = await onFetchOrderItems(callResult.data.order_id);
      if (orderDetails.success) {
        const order = orderDetails.data;
        setShipping({
          ...callResult.data,
          order_id: order.id,
          customer: order.customer,
          orderItems: [...order.products],
        });

        setLoading(false);
      }
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const onFetchOrderItems = async function (id) {
    let callResult = await makePostApiCall(`fetchOrder/${id}`);
    if (callResult.success) {
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    return callResult;
  };

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const updateShippingApiCall = async function (payload) {
    let callResult = await makePostApiCall(
      `updateShipping/${shippingId}`,
      payload,
    );
    if (callResult.success) {
      if (payload.status.value === 5 || payload.status.value === 12) {
        const qbResult = await createInvoiceInQb();
        if (qbResult.success) {
          addSnackbar(
            new SnackbarData(
              generateUniqueNumber(),
              "Shipping sent to Quickbooks",
              SnackbarType.Success,
            ),
          );
        } else {
          showErrorModal(qbResult.data.message);
        }
      } else {
        addSnackbar(
          new SnackbarData(
            generateUniqueNumber(),
            callResult.data.message,
            SnackbarType.Success,
          ),
        );
      }
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const onFetchPackagedItemByBarcode = async function (scannedBarcode) {
    let callResult = await makePostApiCall(
      `fetchPackagedItemByBarcode/${scannedBarcode}`,
    );
    if (callResult.success) {
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    return callResult;
  };

  const addPackagedItemToOrderItem = async function (
    shippingId,
    orderItem,
    packagedItem,
  ) {
    const payload = {
      shippingId: shippingId,
      orderItem: orderItem,
      packagedItem: packagedItem,
    };
    let callResult = await makePostApiCall(
      "addPackagedItemToOrderItem",
      payload,
    );
    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          "Package added to shipping",
          SnackbarType.Success,
        ),
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    return callResult;
  };

  const removeShippedCartonApiCall = async function (carton) {
    console.log("carton", carton);
    const callResult = await makePostApiCall(`removeShippedCarton`, {
      id: carton.id,
      barcode: carton.barcode,
      carton_type: carton.carton_type,
    });
    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success,
        ),
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    return callResult;
  };

  const getEmployeesForDropdown = async function (type, department) {
    const payload = { department: department, type: type };
    let callResult = await makePostApiCall(`employeesForDropdown`, payload);

    if (callResult.success) {
      setEmployeeOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    return callResult;
  };

  const deleteShipping = async function () {
    let callResult = await makePostApiCall(`shippings/delete/${shippingId}`);

    if (callResult.success) {
      window.location = "/shippings";
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.error);
    }
  };

  const printShipping = async function () {
    let callResult = await makePostApiCall(`printShipping/${shippingId}`);

    if (callResult.success) {
      window.open(callResult.data.location, "_blank");
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const quickAddPackagedItemToOrderItem = async function (
    shippingId,
    orderItemId,
    lotItem,
    original_scanned_amount,
  ) {
    const payload = {
      shippingId: shippingId,
      orderItemId: orderItemId,
      lotItem: lotItem,
      original_scanned_amount: original_scanned_amount,
    };
    let callResult = await makePostApiCall(
      "quickAddPackagedItemToOrderItem",
      payload,
    );
    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          "Package(s) added to shipping",
          SnackbarType.Success,
        ),
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    return callResult;
  };

  const fetchPackagedItemsForQuickScan = async function (payload) {
    let callResult = await makePostApiCall(
      `fetchPackagedItemsForQuickScan`,
      payload,
    );
    if (callResult.success) {
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    return callResult;
  };

  const createInvoiceInQb = async function () {
    showProgressModal("Sending shipping to Quickbooks...");
    let callResult = await makePostApiCall(`quickbooks/createInvoice`, {
      shipment_id: shippingId,
    });
    hideProgressModal();
    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          "Shipping sent to Quickbooks",
          SnackbarType.Success,
        ),
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    return callResult;
  };

  const getOrderItemShipments = async function (id) {
    const callResult = await makeGetApiCall(`getOrderItemShipments/${id}`);
    if (callResult.success) {
      const payload = callResult.data ?? {};

      // Expected API shape: `{ order_item: { ..., shipped_cartons: [...] } }`
      const orderItem = payload.order_item ?? {};
      const shippedCartons = Array.isArray(orderItem.shipped_cartons)
        ? orderItem.shipped_cartons
        : [];

      const normalizedShippingItems = shippedCartons.map((carton) => {
        const packagingDate = carton.packaging_date ?? null;

        return {
          // Used by tables as `dataKey="id"`
          id: carton.id,

          // Used by barcodeBody in `OrderItemsForShipping.jsx`
          barcode: carton.barcode,

          // Used by deletion logic in `CreateNewShippingForm.jsx`
          barcode: carton.barcode,

          lot_number: carton.lot_number,
          packing_size: carton.packing_size,
          packaging_date: packagingDate,

          // Used by Quantity column
          carton_count: carton.carton_count,
          carton_type: carton.carton_type,

          // Used by deletion logic (`product_id`)
          product_id: orderItem.product_id,

          // Extra fields that might be useful elsewhere
          product_name: carton.product_name,
          plu: carton.plu,
          serial_number: carton.serial_number,
          best_before_date: carton.best_before_date,
          status: carton.status,
          description_en: carton.description_en,
          product_temperature: orderItem.product_temperature,
          order_item_id: orderItem.id,

          // Optional flags
          is_quick_scan: carton.is_quick_scan ?? false,
        };
      });

      return { success: true, data: normalizedShippingItems };
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
      return { success: false };
    }
  };

  const setProductTemperature = async function (
    productId,
    temperature,
    order_id,
  ) {
    let callResult = await makePostApiCall(`setProductTemperature`, {
      product_id: productId,
      temperature: temperature,
      order_id: order_id,
    });
    if (callResult.success) {
      return callResult;
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    return callResult;
  };

  const createShippingRecordByID = async function () {
    let callResult = await makePostApiCall(
      `/qaReports/createShippingRecordByID`,
      {
        shippingId: shippingId,
      },
    );
    if (callResult.success) {
      window.open(callResult.data.location, "_blank");
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
      return null;
    }
  };

  const printShippingLabelToPrinter = async function (labelPayload) {
    const printResult = await makePostApiCallToPrinter({
      ...labelPayload,
    });
    if (!printResult?.success) {
      const errorMessage =
        printResult?.data?.subtitle ??
        printResult?.data?.message ??
        printResult?.data?.title ??
        "Print failed. Please try again.";
      showErrorModal("Print error", errorMessage);
    }
  };

  const generateAndPrintShippingLabel = async function (orderItem) {
    showProgressModal("Generating and printing shipping label...");
    try {
      const callResult = await makePostApiCall(`generateShippingLabel`, {
        shipping_id: shippingId,
        order_item_id: orderItem.id,
        product_id: orderItem.product_id,
      });

      if (callResult.success) {
        const body = callResult.data;
        const labelPayload =
          body &&
          typeof body === "object" &&
          (body.barcode !== undefined || body.customer_name !== undefined)
            ? body
            : body?.data ?? body;
        hideProgressModal();
        await printShippingLabelToPrinter(labelPayload);
      } else {
        hideProgressModal();
        if (callResult.errorStatus === 401) {
          logout();
        }
        showErrorModal(callResult.data.message);
        return null;
      }
    } catch (error) {
      hideProgressModal();
      showErrorModal(error?.message ?? "Failed to generate shipping label");
      return null;
    }
  };

  return {
    onFetchOrderItems,
    loading,
    setEmptyModelOpen,
    setSlideOver,
    slideOver,
    emptyModal,
    showErrorModal,
    updateShippingApiCall,
    shipping,
    onFetchPackagedItemByBarcode,
    addPackagedItemToOrderItem,
    getShippingDetails,
    removeShippedCartonApiCall,
    employeeOptions,
    getEmployeesForDropdown,
    deleteShipping,
    printShipping,
    quickAddPackagedItemToOrderItem,
    fetchPackagedItemsForQuickScan,
    createInvoiceInQb,
    getOrderItemShipments,
    createShippingRecordByID,
    setProductTemperature,
    generateAndPrintShippingLabel,
  };
}
